(function () {
  const API_BASE = 'https://aa.usno.navy.mil/api/moon/phases/year?year=';
  const MIN_YEAR = 1700;
  const MAX_YEAR = 2100;

  const months = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre'
  ];

  const phases = {
    'New Moon': {
      label: 'Nouvelle Lune',
      icon: '●',
      advice: 'Rituel conseillé : écrire 1 à 3 intentions précises, choisir un objet ou une bougie pour les représenter, puis le garder sur l’autel jusqu’au premier quartier.'
    },
    'First Quarter': {
      label: 'Premier Quartier',
      icon: '☽',
      advice: 'Rituel conseillé : faire une action concrète liée à l’intention, retirer un obstacle identifiable, ajuster la demande si elle est trop vague.'
    },
    'Full Moon': {
      label: 'Pleine Lune',
      icon: '○',
      advice: 'Rituel conseillé : charger outils, eau lunaire ou cristaux, consacrer un talisman, remercier pour ce qui a abouti et noter ce qui doit être terminé.'
    },
    'Last Quarter': {
      label: 'Dernier Quartier',
      icon: '☾',
      advice: 'Rituel conseillé : nettoyer l’autel, jeter ou brûler une liste de choses à couper, faire un bain ou une fumigation de purification.'
    }
  };

  const filterOptions = [
    { value: 'all', label: 'Toutes' },
    { value: 'New Moon', label: 'Nouvelle Lune' },
    { value: 'First Quarter', label: 'Premier Quartier' },
    { value: 'Full Moon', label: 'Pleine Lune' },
    { value: 'Last Quarter', label: 'Dernier Quartier' }
  ];

  function initCalendar(calendar) {
    const form = calendar.querySelector('[data-lunar-form]');
    const yearInput = calendar.querySelector('[data-lunar-year]');
    const monthSelect = calendar.querySelector('[data-lunar-month-select]');
    const currentYear = new Date().getFullYear();

    yearInput.value = String(currentYear);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      loadYear(calendar, Number(yearInput.value));
    });

    yearInput.addEventListener('change', function () {
      loadYear(calendar, Number(yearInput.value));
    });

    function scrollToSelectedMonth() {
      const monthSection = calendar.querySelector('#' + monthSelect.value);
      if (!monthSection) return;

      monthSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    monthSelect.addEventListener('change', scrollToSelectedMonth);
    monthSelect.addEventListener('input', scrollToSelectedMonth);

    calendar.addEventListener('click', function (event) {
      const button = event.target.closest('[data-lunar-filter]');
      if (!button) return;

      applyPhaseFilter(calendar, button.dataset.lunarFilter);
    });

    loadYear(calendar, currentYear);
  }

  async function loadYear(calendar, year) {
    const yearInput = calendar.querySelector('[data-lunar-year]');
    const status = calendar.querySelector('[data-lunar-status]');
    const monthSelect = calendar.querySelector('[data-lunar-month-select]');
    const filters = calendar.querySelector('[data-lunar-filters]');
    const nextPhase = calendar.querySelector('[data-lunar-next-phase]');
    const grid = calendar.querySelector('[data-lunar-grid]');

    if (!Number.isInteger(year) || year < MIN_YEAR || year > MAX_YEAR) {
      status.textContent = `Veuillez choisir une année entre ${MIN_YEAR} et ${MAX_YEAR}.`;
      return;
    }

    yearInput.value = String(year);
    monthSelect.innerHTML = '';
    filters.innerHTML = '';
    nextPhase.hidden = true;
    nextPhase.innerHTML = '';
    grid.innerHTML = createSkeleton();
    grid.setAttribute('aria-busy', 'true');
    status.textContent = `Chargement des phases lunaires ${year}...`;

    try {
      const data = await fetchMoonPhases(year);
      renderCalendar(calendar, year, data.phasedata || []);
      status.textContent = `Phases lunaires ${year} chargées depuis l'U.S. Naval Observatory. Heures indiquées en UTC.`;
    } catch (error) {
      console.error('Erreur calendrier lunaire:', error);
      renderError(calendar, year);
      status.textContent = "Impossible de charger les phases lunaires. Aucune donnée de remplacement n'est affichée.";
    } finally {
      grid.setAttribute('aria-busy', 'false');
    }
  }

  async function fetchMoonPhases(year) {
    const response = await fetch(API_BASE + encodeURIComponent(year), {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('HTTP ' + response.status);
    }

    const data = await response.json();
    if (data.error) {
      throw new Error(data.error);
    }

    return data;
  }

  function renderCalendar(calendar, year, phaseData) {
    const monthSelect = calendar.querySelector('[data-lunar-month-select]');
    const filters = calendar.querySelector('[data-lunar-filters]');
    const nextPhase = calendar.querySelector('[data-lunar-next-phase]');
    const grid = calendar.querySelector('[data-lunar-grid]');
    const grouped = groupByMonth(phaseData);
    const currentMonthIndex = getCurrentMonthIndex(year);

    monthSelect.innerHTML = months.map(function (month, index) {
      const monthId = monthSectionId(calendar, year, index);
      const isCurrent = index === currentMonthIndex;
      return `<option value="${monthId}" ${isCurrent ? 'selected' : ''}>${month}${isCurrent ? ' - mois en cours' : ''}</option>`;
    }).join('');

    filters.innerHTML = createFilterButtons();
    nextPhase.innerHTML = createNextPhasePanel(year, phaseData);
    nextPhase.hidden = false;
    grid.innerHTML = months.map(function (month, index) {
      const items = grouped.get(index + 1) || [];
      return createMonthSection(calendar, year, month, index, items, currentMonthIndex);
    }).join('');
    grid.insertAdjacentHTML('beforeend', '<p class="lunar-filter-empty is-hidden" data-lunar-filter-empty>Aucune phase ne correspond à ce filtre pour cette année.</p>');
    applyPhaseFilter(calendar, 'all');
  }

  function renderError(calendar, year) {
    const grid = calendar.querySelector('[data-lunar-grid]');

    grid.innerHTML = `
      <div class="lunar-error" role="alert">
        <h2>Calendrier indisponible</h2>
        <p>La source des phases lunaires ne répond pas pour le moment. Réessayez sans afficher de données approximatives.</p>
        <button type="button" class="lunar-button" data-lunar-retry>Réessayer</button>
      </div>
    `;

    grid.querySelector('[data-lunar-retry]').addEventListener('click', function () {
      loadYear(calendar, year);
    });
  }

  function groupByMonth(phaseData) {
    return phaseData.reduce(function (grouped, item) {
      if (!grouped.has(item.month)) grouped.set(item.month, []);
      grouped.get(item.month).push(item);
      return grouped;
    }, new Map());
  }

  function createMonthSection(calendar, year, month, index, items, currentMonthIndex) {
    const monthId = monthSectionId(calendar, year, index);
    const cards = items.map(createPhaseCard).join('');
    const currentBadge = index === currentMonthIndex ? '<span>Mois en cours</span>' : '';

    return `
      <section class="lunar-month-section ${index === currentMonthIndex ? 'is-current' : ''}" id="${monthId}" data-lunar-month-section>
        <h2>${month} ${currentBadge}</h2>
        <div class="lunar-cards">
          ${cards || '<p class="lunar-empty">Aucune phase principale pour ce mois.</p>'}
        </div>
      </section>
    `;
  }

  function createPhaseCard(item) {
    const phase = getPhaseInfo(item.phase);

    return `
      <article class="lunar-card" data-lunar-phase="${item.phase}">
        <span class="lunar-phase-icon" aria-hidden="true">${phase.icon}</span>
        <div class="lunar-card-content">
          <h3>${phase.label}</h3>
          <p class="lunar-date">${formatPhaseDate(item)} à ${item.time} UTC</p>
          <p>${phase.advice}</p>
        </div>
      </article>
    `;
  }

  function createNextPhasePanel(year, phaseData) {
    const next = findNextPhase(year, phaseData);

    if (!next) {
      return `
        <article class="lunar-next-card">
          <div>
            <p class="lunar-kicker">Prochaine phase</p>
            <h2>Aucune phase à venir dans cette année</h2>
            <p>Choisissez l'année en cours ou une année future pour afficher la prochaine phase lunaire.</p>
          </div>
        </article>
      `;
    }

    const phase = getPhaseInfo(next.phase);

    return `
      <article class="lunar-next-card">
        <span class="lunar-phase-icon" aria-hidden="true">${phase.icon}</span>
        <div>
          <p class="lunar-kicker">Prochaine phase</p>
          <h2>${phase.label}</h2>
          <p class="lunar-date">${formatPhaseDate(next)} à ${next.time} UTC</p>
          <p>${phase.advice}</p>
        </div>
      </article>
    `;
  }

  function createFilterButtons() {
    return filterOptions.map(function (option) {
      return `
        <button
          type="button"
          class="${option.value === 'all' ? 'active' : ''}"
          data-lunar-filter="${option.value}"
          aria-pressed="${option.value === 'all' ? 'true' : 'false'}"
        >
          ${option.label}
        </button>
      `;
    }).join('');
  }

  function applyPhaseFilter(calendar, phaseName) {
    const filter = phaseName || 'all';
    const cards = calendar.querySelectorAll('[data-lunar-phase]');
    const sections = calendar.querySelectorAll('.lunar-month-section');
    const empty = calendar.querySelector('[data-lunar-filter-empty]');
    let visibleCards = 0;

    calendar.querySelectorAll('[data-lunar-filter]').forEach(function (button) {
      const isActive = button.dataset.lunarFilter === filter;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    cards.forEach(function (card) {
      const isVisible = filter === 'all' || card.dataset.lunarPhase === filter;
      card.classList.toggle('is-hidden', !isVisible);
      card.setAttribute('aria-hidden', String(!isVisible));
      if (isVisible) visibleCards += 1;
    });

    sections.forEach(function (section) {
      const hasVisibleCard = Boolean(section.querySelector('[data-lunar-phase]:not(.is-hidden)'));
      section.classList.toggle('is-hidden', !hasVisibleCard);
      section.setAttribute('aria-hidden', String(!hasVisibleCard));
    });

    if (empty) {
      empty.classList.toggle('is-hidden', visibleCards > 0);
      empty.setAttribute('aria-hidden', String(visibleCards > 0));
    }
  }

  function findNextPhase(year, phaseData) {
    const now = new Date();
    const nowYear = now.getUTCFullYear();
    const sorted = phaseData.slice().sort(function (a, b) {
      return phaseDate(a) - phaseDate(b);
    });

    if (year > nowYear) return sorted[0] || null;
    if (year < nowYear) return null;

    return sorted.find(function (item) {
      return phaseDate(item) >= now;
    }) || null;
  }

  function getPhaseInfo(phaseName) {
    return phases[phaseName] || {
      label: phaseName,
      icon: '☾',
      advice: 'Utilisez cette phase comme repère de calendrier avant de choisir un rituel.'
    };
  }

  function getCurrentMonthIndex(year) {
    const now = new Date();
    return now.getFullYear() === year ? now.getMonth() : -1;
  }

  function phaseDate(item) {
    const parts = String(item.time || '00:00').split(':');
    return new Date(Date.UTC(
      item.year,
      item.month - 1,
      item.day,
      Number(parts[0]) || 0,
      Number(parts[1]) || 0
    ));
  }

  function formatPhaseDate(item) {
    const date = new Date(Date.UTC(item.year, item.month - 1, item.day));
    return new Intl.DateTimeFormat('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC'
    }).format(date);
  }

  function monthSectionId(calendar, year, index) {
    return `lunar-${calendar.dataset.sectionId}-${year}-${index + 1}`;
  }

  function createSkeleton() {
    return Array.from({ length: 4 }).map(function () {
      return `
        <div class="lunar-card lunar-card-skeleton">
          <span class="lunar-phase-icon"></span>
          <div class="lunar-card-content">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      `;
    }).join('');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lunar-calendar]').forEach(initCalendar);
  });
})();
